const MenuAncoragem = () => {
    const components = document.querySelectorAll('[data-component="menu_ancoragem"]');

    components.forEach(component => {
        const links = component.querySelectorAll('.anchor-item');
        const sections = Array.from(links).map(link => {
            const id = link.getAttribute('href').replace('#', '');
            return document.getElementById(id);
        });

        // offset fixo
        const offsetTotal = 68;

        // ativa o primeiro ao carregar
        if (links.length) {
            links.forEach(l => l.classList.remove('active'));
            links[0].classList.add('active');
        }

        // clique com scroll
        links.forEach(link => {
            link.addEventListener('click', e => {
                e.preventDefault();
                const id = link.getAttribute('href').replace('#', '');
                const target = document.getElementById(id);

                if (target) {
                    const top = target.getBoundingClientRect().top + window.pageYOffset - offsetTotal;

                    window.scrollTo({
                        top,
                        behavior: 'smooth'
                    });
                }
            });
        });

        let currentActiveIndex = 0;

function onScroll() {
    let scrollPos = window.scrollY + offsetTotal + 10;

    sections.forEach((section, i) => {
        if (!section) return;

        if (
            scrollPos >= section.offsetTop &&
            scrollPos < section.offsetTop + section.offsetHeight
        ) {
            if (currentActiveIndex !== i) {
                currentActiveIndex = i;

                links.forEach(l => l.classList.remove('active'));
                links[i].classList.add('active');

                // Auto scroll horizontal somente no mobile
                if (window.innerWidth < 1024) {
                    links[i].scrollIntoView({
                        behavior: 'smooth',
                        inline: 'center',
                        block: 'nearest'
                    });
                }
            }
        }
    });
}


        window.addEventListener('scroll', onScroll);
        onScroll();
    });
};

export default MenuAncoragem;

if (document.querySelectorAll('[data-component="menu_ancoragem"]').length) {
    MenuAncoragem();
}
